import styled from 'styled-components';

export default {
  Section: styled.section<{ backgroundColor: string }>`
    display: flex;
    justify-content: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
  `,
};
